<template>
  <div class="auth-wrapper">
    <div class="auth-image" />
    <div class="main-container">
      <slot />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.auth-wrapper {
  display: flex;
}

.auth-image {
  width: 35%;
  background-image: url('@/assets/img/login-bg.webp');
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}

.main-container {
  display: flex;
  justify-content: center;
  flex: 1;
}
</style>
